import React from "react";
import c from "./ParkingItem.module.scss";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";

interface IProps {
  children?: React.ReactNode;
  percentage: number
  name: string
  description: string
  freePlaces: number
  directionIcon: React.ReactNode

}

const ParkingItem: React.FC<IProps> = ({ percentage, name, description, freePlaces, directionIcon }) => {
  const getColor = (value: number) => {
    if (value < 50) return "rgba(0, 205, 104, 1)"; // червоний
    if (value < 70) return "rgba(255, 170, 0, 1)"; // жовтий
    return "#ff4d4f"; // зелений
  };

  return (
    <div className={c.parkingItem}>
      <div className={c.parkingItemPercentageWrapper}>
        <div className={c.parkingItemPercentage}>
          {/*@ts-ignore*/}
          <CircularProgressbar
            value={percentage} text={`${percentage}%`}
            styles={{
              ...buildStyles({
                pathColor: getColor(percentage),
                textColor: "#fff",
                trailColor: "rgba(255, 255, 255, 0.2)",
              }),
              text: {
                fill: "#fff",
                dominantBaseline: "middle",
                textAnchor: "middle",
                fontSize: "22px",
              },
            }}
          />
        </div>
        <div>
        <div className={c.parkingItemName}>
          {name}
        </div>
          <div className={c.parkingItemDescription}>
            {description}
          </div>
        </div>
      </div>

      <div className={c.parkingItemPlacesWrapper}>
        <div className={c.parkingItemPlaces}>
          {freePlaces}
        </div>

        <div className={c.parkingItemIcon}>
          {directionIcon}
        </div>
      </div>
    </div>
  );
};

export default ParkingItem;